import React, { ReactNode } from "react";

import Spinner from "@components/Spinner/spinner";

import Modal from "./modal";

interface LoadingModalProps {
  isOpen: boolean;
  children: ReactNode;
}

const LoadingModal = ({ isOpen, children }: LoadingModalProps) => (
  <Modal closeIcon={false} closeOnOutsideClick={false} open={isOpen}>
    <Modal.Content className="flex flex-col items-center justify-center">
      <p className="text-neutral-900 font-semibold">{children}</p>
      <Spinner className="mt-3" />
    </Modal.Content>
  </Modal>
);

export default LoadingModal;
